var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"body-2 mr-2",class:_vm.navbar ? 'tw-text-gray-600' : 'tw-text-gray-300'},[_vm._v(_vm._s(_vm.timer.display))]),_c('v-progress-circular',{attrs:{"rotate":"270","value":_vm.timer.progress,"color":_vm.navbar ? 'blue' : 'white'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }